import { Component, OnInit } from '@angular/core';
import { ComposedRail } from '../models/store-rail.model';
import { LandingRailComposerService } from '../services/landing-rail-composer.service';

@Component({
  selector: 'app-rail-lab',
  templateUrl: './rail-lab.component.html',
  styleUrls: ['../home.component.scss', './rail-lab.component.scss'],
  standalone: false,
})
export class RailLabComponent implements OnInit {
  rails: ComposedRail[] = [];

  constructor(private railComposer: LandingRailComposerService) {}

  ngOnInit(): void {
    this.rails = this.railComposer.composeDensityGallery();
  }

  trackRail(_i: number, rail: ComposedRail): string {
    return rail.id;
  }
}
